import { Link } from "react-router-dom";
import ReactSelect from 'react-select';

var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");
var AddNewStudentModal = require("components/org/roster/AddNewStudentModal");
var AddNewAdminModal = require("components/appdev/wizards/AddNewAdminModal");
var RosteringMethodModal = require("components/appdev/wizards/RosteringMethodModal");

require("appdev/wizards/org_controls.scss");

class OrgControls extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			newStudentCap: null, editingStudentCap: false, editingSchoolName: false, editingDistrictOrg: false, editingStudentListID: false,
			editingCanonicalSchoolData: false, newAdminID: null, newAdminName: null, newSchoolOrgName: null, newAdminEmail: null, newDistrictOrgID: null,
			newCanonicalSchoolID: null, loading: false, addingSchoolOrgAdmin: false, canonicalSchool: {}
		}
	}

	openAddStudentModal(e) {
		$wr.nope(e)
		this.refs.addStudentModal.show();
	}

	openAddNewAdminModal(e) {
		$wr.nope(e)
		this.refs.addNewAdminModal.show();
	}

	openRosteringMethodModal(e) {
		$wr.nope(e)
		this.refs.rosteringMethodModal.show();
	}

	/////////////// student list editing //////////////////////////////
	updateSchoolOrgName(event) {
		this.setState({ newSchoolOrgName: event.target.value });
	}
	updateAdminID(event) {
		this.setState({ newAdminID: event.target.value });
	}
	updateAdminName(event) {
		this.setState({ newAdminName: event.target.value });
	}
	updateAdminEmail(event) {
		this.setState({ newAdminEmail: event.target.value });
	}
	openAddSchoolOrgAdmin() {
		this.setState({ addingSchoolOrgAdmin: true });
	}
	openAddAdmin(studentListID) {
		this.setState({ editingStudentListID: studentListID });
	}
	addExistingSubAdmin(e) {
		$wr.nope(e)
		var adminData = { sub_admin_id: this.state.newAdminID };
		this.updateStudentList(this.state.editingStudentListID, adminData);
	}
	createNewSubAdmin(e) {
		$wr.nope(e)
		var adminData = { new_sub_admin: { name: this.state.newAdminName, email: this.state.newAdminEmail } };
		this.updateStudentList(this.state.editingStudentListID, adminData);
	}
	removeSubAdmin(studentListID, adminID, e) {
		$wr.nope(e)
		var adminData = { remove_sub_admin_id: adminID };
		this.updateStudentList(studentListID, adminData);
	}
	makeAdminPrimary(studentListID, adminID, e) {
		$wr.nope(e)
		var adminData = { primary_admin_id: adminID };
		this.updateStudentList(studentListID, adminData);
	}
	updateStudentListStatus(studentListID, isActive, e) {
		$wr.nope(e)
		var studentListData = { inactive: isActive };
		this.updateStudentList(studentListID, studentListData);
	}
	updateStudentList(studentListID, studentListData) {
		this.setState({ loading: true, editingStudentListID: null, newAdminID: null,
			newAdminName: null, newAdminEmail: null });

		var params = { student_list: studentListData, effective_user_id: this.props.schoolOrg.primary_admin.id }
		CurrentUser.api().patchStudentList(studentListID, params, $wr.apiHandler((response) => {
			this.setState({ loading: false });
			if (response.student_list.errors) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Sorry!", text: response.student_list.errors.join(", "), 
					icon: "exclamation-sign", type: "error" });
			} else {
				window.wrNotifications.triggerDropDownNotification({
					title: "Success!", text: "It worked like magic.", icon: "ok-sign" });

				this.props.fetchSchoolOrgDetailsF(true);
			}
		}));
	}
	updateDistrictOrgID(event) {
		this.setState({ newDistrictOrgID: event.target.value });
	}
	updateCanonicalSchool(newCanonicalSchool) {
		this.setState({ newCanonicalSchool });
	}
	updateCanonicalSchoolID(event) {
		this.setState({ newCanonicalSchoolID: event.target.value });
	}

	renderAddAdminField(studentListID) {
		if (this.state.editingStudentListID == studentListID) {
			return (
				<div>
					<div className="existingAdminForm">
						Existing:
						<input type="text" placeholder="Admin ID"
							onChange={ this.updateAdminID }
							className="form-control" />
						<LoadingButton className="btn buttonSuccess"
							onClick={ this.addExistingSubAdmin }
							loading={ this.state.loading } text="Add Existing" />
					</div>
					<div className="newAdminForm">
						New:
						<input type="text" placeholder="Name"
							onChange={ this.updateAdminName }
							className="form-control" />
						<input type="text" placeholder="Email"
							onChange={ this.updateAdminEmail }
							className="form-control" />
						<LoadingButton className="btn buttonSuccess"
							onClick={ this.createNewSubAdmin }
							loading={ this.state.loading } text="Create New" />
					</div>
				</div>
			);
		} else {
			return (
				<a onClick={ this.openAddAdmin.bind(this, studentListID) }>
					Add Sub-Admin
				</a>
			);
		}
	}
	renderAddSchoolOrgAdminField() {
		if (this.state.addingSchoolOrgAdmin) {
			return (
				<div className="newAdminForm">
					New:
					<input type="text" placeholder="Name"
						onChange={ this.updateAdminName }
						className="form-control" />
					<input type="text" placeholder="Email"
						onChange={ this.updateAdminEmail }
						className="form-control" />
					<LoadingButton className="btn buttonSuccess"
						onClick={ this.submitAction.bind(this, "new_school_org_admin") }
						loading={ this.state.loading } text="Create New" />
				</div>
			);
		} else {
			return (
				<a onClick={ this.openAddSchoolOrgAdmin }>
					Add School Org Admin
				</a>
			);
		}
	}
	renderStudentListDisplay(studentList, isActive) {
		var adminsDisplay = _.map(studentList.admins, (admin) => {
			return this.renderAdminDisplay(admin, studentList);
		});

		// only display link if not loading
		if (!this.state.loading) {
			if (isActive) {
				var archiveText = "Archive";
			} else {
				var archiveText = "Unarchive";
			}
		}

		return (
			<div key={ studentList.id } className="studentListSection">
				{ studentList.name } (List ID: { studentList.id })
				<a onClick={ this.updateStudentListStatus.bind(this, studentList.id, isActive) }>
					{ archiveText }
				</a>
				<ul>
					{ adminsDisplay }
				</ul>
				{ this.renderAddAdminField(studentList.id) }
			</div>
		);
	}
	///////////////////////////////////////////////////////////////////

	/////////////// school org section editing ////////////////////////
	updateStudentCap(event) {
		this.setState({ newStudentCap: event.target.value });
	}
	toggleEditStudentCap() {
		this.setState({ editingStudentCap: !this.state.editingStudentCap });
	}
	submitAction(action) {
		this.setState({ loading: true, editingStudentCap: false, addingSchoolOrgAdmin: false });

		if (action == "student_count_cap") {
			var updatedValue = this.state.newStudentCap;
		} else if (action == "new_school_org_admin") {
			var updatedValue = { name: this.state.newAdminName, email: this.state.newAdminEmail };
		} else if (action == 'school_org_name') { 
			var updatedValue = this.state.newSchoolOrgName
		} else if (action == 'district_org_id') {
			var updatedValue = this.state.newDistrictOrgID
		} else if (action == 'canonical_school_data') {
			var updatedValue = this.state.newCanonicalSchool
		} else if (action == 'canonical_school_id') {
			var updatedValue = this.state.newCanonicalSchoolID
		} else {
			var updatedValue = true;
		}

		var actionHash = {};
		actionHash[action] = updatedValue;
		var params = { school_org: actionHash };

		CurrentUser.api().patchSchoolOrg(this.props.schoolOrg.id, params, $wr.apiHandler((response) => {
			this.setState({ loading: false, newAdminName: null, newAdminEmail: null });
			if (response.school_org.errors) {
				if (action == "student_count_cap") { this.toggleEditStudentCap(); }
				window.wrNotifications.triggerDropDownNotification({
					title: "Sorry!", text: response.school_org.errors.join(", "), 
					icon: "exclamation-sign", type: "error" });
			} else {
				setTimeout(() => {
					window.wrNotifications.triggerDropDownNotification({
						title: "Success!", text: "It worked like magic.", icon: "ok-sign" });
					}, 1000);

				this.props.fetchSchoolOrgDetailsF(true);
			}
		}));
	}
	renderStudentCapField() {
		var displayedStudentCap = this.state.newStudentCap || this.props.schoolOrg.student_count_cap || "???";

		if (this.state.editingStudentCap) {
			return (
				<input type="text" defaultValue={ displayedStudentCap }
					onChange={ this.updateStudentCap }
					className="form-control" />
			);
		} else {
			var editIcon = (<Glyphicon icon="pencil" className="editIcon" />);
			return (
				<span className="editable" onClick={ this.toggleEditStudentCap }>
					<span className="clickableElement">{ displayedStudentCap }</span> { editIcon }
				</span>
			);
		}
	}

	renderDistrictOrgIdField() {
		var { schoolOrg } = this.props
		var { editingDistrictOrg } = this.state

		var district_org_id = !_.isEmpty(schoolOrg.district_org) ? schoolOrg.district_org.id : null

		if (editingDistrictOrg) {
			return (
				<input type="text" defaultValue={district_org_id}
					onChange={this.updateDistrictOrgID}
					className="form-control" />
			);
		} else {
			var editIcon = (<Glyphicon icon="pencil" className="editIcon" />);
			return (
				<span className="editable" onClick={() => { this.setState({ editingDistrictOrg: !editingDistrictOrg }) }}>
					<span className="boldText clickableElement">{district_org_id}</span> {editIcon}
				</span>
			);
		}
	}

	renderSchoolOrgNameField() {
		var { name } = this.props.schoolOrg
		var { editingSchoolName } = this.state

		if (editingSchoolName) {
			return (
				<input type="text" defaultValue={name}
					onChange={ this.updateSchoolOrgName }
					className="form-control" />
			);
		} else {
			var editIcon = (<Glyphicon icon="pencil" className="editIcon" />);
			return (
				<span className="editable" onClick={() => {this.setState({ editingSchoolName: !editingSchoolName })}}>
					<span className="boldText clickableElement">{ name }</span> { editIcon }
				</span>
			);
		}
	}


	renderAdminDisplay(admin, studentList = null) {
		if (studentList) {
			if (studentList.primary_admin && (studentList.primary_admin.id == admin.id)) {
				var primaryControl = (<Glyphicon icon="asterisk" />);
			} else {
				// only display these controls if not loading
				if (!this.state.loading) {
					var primaryControl = (
						<span>
							<span className="verticalDivider"></span>
							<a onClick={ this.makeAdminPrimary.bind(this, studentList.id, admin.id) }>
								Make Primary
							</a>
							<span className="verticalDivider"></span>
							<a onClick={ this.removeSubAdmin.bind(this, studentList.id, admin.id) } className="removeLink">
								Remove
							</a>
						</span>
					);
				}
			}
			var studentListWithStats = _.where(this.props.schoolOrg.student_lists, { id: studentList.id })[0].statistics;
			if (studentListWithStats) {
				var studentCount = studentListWithStats.meta_data.student_count;
				var studentsActive = this.roundPercent(studentListWithStats.last_active.month);
				var lastActiveDate = $wr.formatDate(admin.last_active, "MM-DD-YYYY")
				if (admin.role != "adminRole") {
					var totalStudents = (<span>Total Students: { studentCount }<span className="verticalDivider" /></span>)
					var activeStudents = (<span>30 Day Active: { studentsActive }<span className="verticalDivider" /></span>)
					var activeTeacher = (<span>Last Active: { lastActiveDate }</span>)
				}				
			}
		}
		return (
			<li key={ admin.id }>
				{ admin.first_name } { admin.last_name } (Admin ID: { admin.id })
				<Link to={ "/users/" + admin.id + "/details" } target="_blank">
					Drill
				</Link>
				
				{ primaryControl }
				<span className="verticalDivider" />
				<div className="statsContainer">
					{ totalStudents }
					{ activeStudents }
					{ activeTeacher }
				</div>
			</li>
		);
	}

	roundPercent(decimal) {
		return (decimal * 100).toFixed(1) + "%";
	}

	saveButton(action) {
		return (
			<LoadingButton className="btn buttonSuccess"
				onClick={this.submitAction.bind(this, action)}
				loading={this.state.loading} text="Save" />
		)
	}

	///////////////////////////
	//// Canonical School ////
	///////////////////////////

	getCanonicalSchoolData() {
		var { canonical_id } = this.props.schoolOrg.school
		if (canonical_id) {
			var url = WhooosReadingServices.CanonicalSchools.url(`/schools/${canonical_id}`, {});

			// request canonical data
			$.getJSON(url, (data) => {
				if (data && data.school) {
					this.setState({ canonicalSchool: data.school })
				}
			});
		}
	}

	renderCanonicalDataField(attribute, canonicalSchool) {
		var { editingCanonicalSchoolData } = this.state

		if (editingCanonicalSchoolData) {
			return (
				<input key={attribute} type="text" defaultValue={canonicalSchool[attribute]}
					onChange={(e) => this.updateCanonicalSchool({ ...canonicalSchool, [attribute]: e.target.value })}
					className="form-control" />
			);
		} else {
			var editIcon = (<Glyphicon key={`${attribute}-edit`} icon="pencil" className="editIcon" />);
			return (
				<span key={attribute} className="editable" onClick={() => { this.setState({ editingCanonicalSchoolData: !editingCanonicalSchoolData }) }}>
					<span className="boldText clickableElement">{canonicalSchool[attribute]}</span> {editIcon}
				</span>
			);
		}
	}

	renderCanonicalIDField(canonicalSchool) {
		var { editingCanonicalID } = this.state

		if (editingCanonicalID) {
			return (
				<input type="text" defaultValue={canonicalSchool.id}
					onChange={this.updateCanonicalSchoolID}
					className="form-control" />
			);
		} else {
			var editIcon = (<Glyphicon icon="pencil" className="editIcon" />);
			return (
				<span className="editable" onClick={() => { this.setState({ editingCanonicalID: !editingCanonicalID }) }}>
					<span className="boldText clickableElement">{canonicalSchool.id}</span> {editIcon}
				</span>
			);
		}
	}

	renderCanonicalSchoolSection() {
		var { canonicalSchool, editingCanonicalSchoolData, editingCanonicalID } = this.state
		if (!_.isEmpty(canonicalSchool)) {
			return (
				<div>
					<div className="sectionSubHeader">
						Canonical School
					</div>
					<div className="canonicalSchoolControl">
						ID: {this.renderCanonicalIDField(canonicalSchool)}
						{ editingCanonicalID && this.saveButton('canonical_school_id') }
					</div>
					{_.map(_.keys(_.omit(canonicalSchool, 'id')), k => {
						return (
							<div key={`canonicalSchoolControl-${k}`} className="canonicalSchoolControl">
								{k}: {this.renderCanonicalDataField(k, canonicalSchool)}
							</div>
						)
					})}
					{editingCanonicalSchoolData && this.saveButton('canonical_school_data')}
				</div>
			)
		}
	}
	///////////////////////////////////////////////////////////////////

	render() {
		var schoolOrg = this.props.schoolOrg;

		var buttonControls = (
			<div className="buttonControls">
				<div className="btn-group">
					<button className="btn buttonPrimary" onClick={ this.openAddStudentModal }>
						Add Students
					</button>
					<button className="btn buttonPrimary" onClick={ this.openAddNewAdminModal }>
						Add Admin
					</button>
					<button className="btn buttonPrimary" onClick={this.openRosteringMethodModal}>
						Rostering Method
					</button>
					{/* <LoadingButton className="btn buttonPrimary"
						onClick={ this.submitAction.bind(this, "send_teacher_logins") }
						loading={ this.state.loading } text="Send Teacher Logins" />
					<LoadingButton className="btn buttonPrimary"
						onClick={ this.submitAction.bind(this, "add_learning_series_banner") }
						loading={ this.state.loading } text="Add LS Banner" /> */}
				</div>
				<div className="btn-group">
					<LoadingButton className="btn buttonWarning"
						onClick={ this.submitAction.bind(this, "skip_census") }
						loading={ this.state.loading } text="Remove" />
					<LoadingButton className="btn buttonDanger"
						onClick={ this.submitAction.bind(this, "deactivate") }
						loading={ this.state.loading } text="Deactivate" />
				</div>
			</div>
		);

		if (schoolOrg.primary_admin) {
			var addStudentModal = (
				<AddNewStudentModal ref="addStudentModal"
					studentLists={ schoolOrg.student_lists }
					selectedTab="upload" effectiveUserID={ schoolOrg.primary_admin.id } />
			);
		}

		var schoolOrgAdmins = _.map(schoolOrg.admins, (admin) => {
			return this.renderAdminDisplay(admin);
		});
		var schoolOrgAdminsDisplay = (
			<div className="schoolOrgAdminsDisplay">
				School Org Admins
				<ul>
					{ schoolOrgAdmins }
				</ul>
				{ this.renderAddSchoolOrgAdminField() }
			</div>
		);

		if (schoolOrg.student_lists.length > 0) {
			var activeStudentLists = _.reject(schoolOrg.student_lists, { inactive: true });
			var inactiveStudentLists = _.where(schoolOrg.student_lists, { inactive: true });

			var activeStudentListAdminsDisplay = _.map(activeStudentLists, (studentList) => {
				return this.renderStudentListDisplay(studentList, true);
			});
			var inactiveStudentListAdminsDisplay = _.map(inactiveStudentLists, (studentList) => {
				return this.renderStudentListDisplay(studentList, false);
			});
		}

		if (schoolOrg.district_org) {
			var districtOrgLink = (
				<Link to={`/district_orgs/${schoolOrg.district_org.id}/details/controls`} target="_blank">
					<span className='districtOrgLink'>Drill</span>
				</Link>
			)
		}

		var { editingSchoolName, editingStudentCap, editingDistrictOrg } = this.state
		var editableControls = (
			<div className="editableControls">
				<div className="sectionSubHeader">
					School Org
				</div>
				<div className="schoolOrgNameControl">
					School Name: {this.renderSchoolOrgNameField()}
					{editingSchoolName && this.saveButton('school_org_name')}
				</div>
				<div className="districtOrgIDControl">
					District Org ID: {this.renderDistrictOrgIdField()} {districtOrgLink}
					{editingDistrictOrg && this.saveButton('district_org_id')}
				</div>
				<div className="studentCapControl">
					Student Cap: { this.renderStudentCapField() }
					{ editingStudentCap && this.saveButton('student_count_cap') }
				</div>
				{ schoolOrgAdminsDisplay }
				{ this.renderCanonicalSchoolSection() }
				<div className="sectionSubHeader">
					Active Student Lists
				</div>
				<div className="studentListAdminsDisplay">
					{ activeStudentListAdminsDisplay }
				</div>
				<div className="sectionSubHeader">
					Inactive Student Lists
				</div>
				<div className="studentListAdminsDisplay">
					{ inactiveStudentListAdminsDisplay }
				</div>
			</div>
		);

		var rosteringMethod = <RosteringMethodModal schoolOrg={this.props.schoolOrg} ref="rosteringMethodModal" />
		var addNewAdminModal = <AddNewAdminModal schoolOrg={schoolOrg} ref="addNewAdminModal" />

		return (
			<div className="orgControls">
				{ buttonControls }
				{ editableControls }
				{ addStudentModal }
				{ addNewAdminModal }
				{ rosteringMethod }
			</div>
		);
	}


	componentDidMount() {
		this.getCanonicalSchoolData()
	}
};

OrgControls.propTypes = PageStrictPropTypes({
	schoolOrg: PropTypes.object.isRequired,
	fetchSchoolOrgDetailsF: PropTypes.func.isRequired,
});

module.exports = OrgControls;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/OrgControls.js